// Spec: 3rd party watermark colour codes (radar Phenomenon.js)
export const INITIALS_COLOR_BY_ALIAS = {
  rising: '#A1E5CD',
  summary: '#A1E5CD',
  cooling: '#9BCFFB',
  wildcard: '#EBB6B4',
  weaksignal: '#D8D8D8',
  established: '#97BACF',
  undefined: '#8FDFC2',
}

export function getGroupInitials(group, publicPhenomenaGroups) {
  const thirdPartyGroup = (Number(group) !== 0 && publicPhenomenaGroups && publicPhenomenaGroups.length)
    ? publicPhenomenaGroups.find((pg) => Number(pg.id) === Number(group))
    : null
  return thirdPartyGroup?.name
    ?.split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .filter(Boolean)
    .join('') || ''
}

export function getInitialsColor(typeAlias) {
  return INITIALS_COLOR_BY_ALIAS[typeAlias] || '#A1E5CD'
}

export function getInitialsFontScale(typeAlias) {
  return String(typeAlias) === 'undefined' ? 0.7 : 1
}

export function getTypeBubbleSize(typeAlias) {
  return String(typeAlias) === 'summary' ? 21 : 16
}
